import React from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

export default function MenuListComposition(props) {
  let { data, func, dataFormatter } = props;
  const classes = useStyles();
  const formattedData = dataFormatter(data);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <MenuList>
          {formattedData.map((item, idx) => (
            <MenuItem
              key={idx}
              onClick={() => {
                func(item);
              }}
            >
              {item.name}
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </div>
  );
}
